import { render, staticRenderFns } from "./LoaderFull.vue?vue&type=template&id=21a8f36c&scoped=true&"
import script from "./LoaderFull.vue?vue&type=script&lang=js&"
export * from "./LoaderFull.vue?vue&type=script&lang=js&"
import style0 from "./LoaderFull.vue?vue&type=style&index=0&id=21a8f36c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a8f36c",
  null
  
)

export default component.exports